import { Component, type ErrorInfo, type ReactNode } from "react";

import { reportProblem } from "./clientLog";

// Story jve-4-4 — catch React render/lifecycle errors (which window 'error' does
// NOT see), report them to the sink, and show a non-crashing fallback so one bad
// subtree doesn't blank the whole app. Wrap the app (or a route subtree) in main.tsx.

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportProblem({
      type: "error",
      name: error.name,
      message: error.message,
      stack: error.stack ?? info.componentStack ?? undefined,
      url: location.pathname,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div role="alert" className="fawkes-error-boundary">
            Er is iets misgegaan. De pagina kan niet worden weergegeven.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
